<h2 mat-dialog-title> <strong>Transaction Details: </strong> #{{data.orderNo}}</h2>
<br>
<mat-dialog-content>
  <div class="row">
    <div class="col-md-6">
      <p><strong>Success:</strong> {{data.transactionData.Success}}</p>
      <p><strong>TransactionId:</strong> {{data.transactionData.TransactionId}}</p>
      <p><strong>Authorization:</strong> {{data.transactionData.Authorization || 'N/A'}}</p>
      <p><strong>Gateway:</strong> {{data.transactionData.Gateway}}</p>
      <p><strong>Transaction Count:</strong> {{data.transactionData.TransactionCount}}</p>
      <p><strong>Currency:</strong> {{data.transactionData.Currency}}</p>
      <p><strong>Customer Name:</strong> {{data.transactionData.CustomerName}}</p>
    </div>
    <div class="col-md-6">
      <p><strong>Payment Status:</strong> {{data.transactionData.PaymentStatus}}</p>
      <p><strong>Order Total:</strong> {{data.transactionData.OrderTotal}} {{data.transactionData.Currency}}</p>
      <p><strong>Captured Amount:</strong> {{data.transactionData.CapturedAmount}} {{data.transactionData.Currency}}</p>
      <p><strong>Tax Amount:</strong> {{data.transactionData.TaxAmount}} {{data.transactionData.Currency}}</p>
      <p><strong>Shipping Charges:</strong> {{data.transactionData.ShippingCharges}} {{data.transactionData.Currency}}</p>
      <p><strong>Validation Status:</strong> {{data.transactionData.ValidationStatus}}</p>
    </div>
  </div>
  <br>
  <mat-expansion-panel>
    <mat-expansion-panel-header class="exp-header">
      <mat-panel-title>All Transactions ({{data.transactionData.AllTransactions.length}})</mat-panel-title>
    </mat-expansion-panel-header>

    <table mat-table [dataSource]="data.transactionData.AllTransactions" class="mat-elevation-z1">
      <ng-container matColumnDef="ShopifyTransactionId">
        <th mat-header-cell *matHeaderCellDef> Shopify Transaction Id </th>
        <td mat-cell *matCellDef="let t"> {{t.ShopifyTransactionId}} </td>
      </ng-container>

      <ng-container matColumnDef="Gateway">
        <th mat-header-cell *matHeaderCellDef> Gateway </th>
        <td mat-cell *matCellDef="let t"> {{t.Gateway}} </td>
      </ng-container>

      <ng-container matColumnDef="Amount">
        <th mat-header-cell *matHeaderCellDef> Amount </th>
        <td mat-cell *matCellDef="let t"> {{t.Amount}} </td>
      </ng-container>

      <ng-container matColumnDef="Authorization">
        <th mat-header-cell *matHeaderCellDef> Authorization </th>
        <td mat-cell *matCellDef="let t"> {{t.Authorization || 'N/A'}} </td>
      </ng-container>

      <ng-container matColumnDef="Kind">
        <th mat-header-cell *matHeaderCellDef> Kind </th>
        <td mat-cell *matCellDef="let t"> {{t.Kind}} </td>
      </ng-container>

      <ng-container matColumnDef="CreatedAt">
        <th mat-header-cell *matHeaderCellDef> Created At </th>
        <td mat-cell *matCellDef="let t"> {{t.CreatedAt | date:'short'}} </td>
      </ng-container>

      <tr mat-header-row
        *matHeaderRowDef="['ShopifyTransactionId','Gateway','Amount','Authorization','Kind','CreatedAt']"></tr>
      <tr mat-row
        *matRowDef="let row; columns: ['ShopifyTransactionId','Gateway','Amount','Authorization','Kind','CreatedAt'];">
      </tr>
    </table>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header class="exp-header">
      <mat-panel-title>Payment Method Summary ({{data.transactionData.PaymentMethodSummary.length}})</mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngFor="let pm of data.transactionData.PaymentMethodSummary">
      <p>
        <strong>Gateway:</strong> {{pm.Gateway}} |
        <strong>Count:</strong> {{pm.Count}} |
        <strong>Total Amount:</strong> {{pm.TotalAmount}}
      </p>

      <mat-expansion-panel>
        <mat-expansion-panel-header class="exp-header">
          <mat-panel-title><strong>Transactions ({{pm.Transactions.length}})</strong></mat-panel-title>
        </mat-expansion-panel-header>

        <ul>
          <li *ngFor="let tx of pm.Transactions">
            <p><strong>Id:</strong> {{tx.Id}}</p>
            <p><strong>Shopify Transaction Id:</strong> {{tx.ShopifyTransactionId}}</p>
          </li>
        </ul>
      </mat-expansion-panel>
      <br>
    </div>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header class="exp-header">
      <mat-panel-title>Validation Details</mat-panel-title>
    </mat-expansion-panel-header>
    <p><strong>Order Total:</strong> {{data.transactionData.Validation_OrderTotal}} {{data.transactionData.Currency}}</p>
    <p><strong>Captured Amount:</strong> {{data.transactionData.Validation_CapturedAmount}} {{data.transactionData.Currency}}</p>
    <p><strong>Difference:</strong> {{data.transactionData.Validation_Difference}} {{data.transactionData.Currency}}</p>
    <p><strong>Message:</strong> {{data.transactionData.Validation_Message}}</p>
  </mat-expansion-panel>


</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-danger" mat-dialog-close>Close</button>
</mat-dialog-actions>